<template>
  <div class="home-container">
    <div class="home-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.name"
          :name="item.id"
          v-for="(item, ind) in tabList"
          :key="ind"
        ></el-tab-pane>
      </el-tabs>
      <playSituation @patrolTask="patrolTask" v-if="activeName == 0"></playSituation>
      <playPoint :patrolTaskDetail="patrolTaskDetail" v-if="activeName == 1"></playPoint>
    </div>
  </div>
</template>

<script>
import playSituation from "./components/playSituation";
import playPoint from "./components/playPoint";
export default {
  components: {
    playSituation,
    playPoint,
  },
  data() {
    return {
      tabList: [
        {
          id: "0",
          name: "路线执行情况",
        },
        {
          id: "1",
          name: "巡更点执行情况",
        },
      ],
      activeName: "0",
      patrolTaskDetail:{}
    };
  },
  mounted() {},
  methods: {
    patrolTask(row,ind){
      this.patrolTaskDetail = row
      this.activeName = '1'
    },
    handleClick(tab, event) {
      this.patrolTaskDetail = {}
      this.activeName = tab.index;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>